<template>
  <div>
    <b-modal
      :id="modalID"
      ref="filemanager"
      size="xl"
      :title="$t('engine.filemanager.title',languageEngine)"
      title-class="fs-db-28"
      header-class="align-items-center px-gd-3 py-gd-2"
      footer-class="align-items-center px-gd-3 py-gd-2"
      body-class="p-0"
      @hidden="onModalHidden"
    >
      <template #default>
        <div class="d-flex">
          <Wrapper :width="210" class="d-flex flex-column px-gd-2 pt-gd-2">
            <CreateFolder @callback="callbackdir" v-if="isShowImage" />
            <div class="fs-dbb-20 px-gd-1 mt-gd-1">
              <h5>{{$t('engine.filemanager.siteFile',languageEngine)}}</h5>
            </div>
            <SystemDirectory
              v-if="!loadingGetSysDir"
              @callback="callback"
              @getSystemDirectories="getSystemDirectories"
              :defaultDirectory="defaultDirectory"
              :selectDirectoryID="selectDirectoryID"
              :siteFileDirectory="siteFileDirectory"
              :isShowDocument="isShowDocument"
              :isShowImage="isShowImage"
            />
            <ExternalDirectory
              v-if="isShowImage"
              @getUnsplashPhoto="getUnsplashPhoto"
              @getFlaticon="getFlaticonPacks"
              @getIcon="getIcons"
              :selectDirectoryID="selectDirectoryID"
              :siteFileDirectory="siteFileDirectory"
              :isShowDocument="isShowDocument"
              :isShowImage="isShowImage"
              :isShowUnsplash="isShowUnsplash"
              :isShowFlaticon="isShowFlaticon"
              :isShowIcon="isShowIcon"
            />
          </Wrapper>
          <Wrapper
            class="flex-grow-1 px-gd-3 pt-gd-2 position-relative"
            @dragover.prevent
            @drop.prevent
          >
            <UploadArea
              ref="UploadArea"
              v-if="selectDirectoryType === 'system'"
              @callback="callback"
              @getDisk="checkDisk"
              @countUpload="setCountUpload"
              @countUploadError="setCountUploadError"
              @fileUpload="setFileUpload"
              @rerenderProgress="setRerenderProgress"
              @uploadedFiles="setUploadedFiles"
              @hasUpload="setHasUpload"
              :selectDirectoryName="selectDirectoryName"
              :selectDirectoryID="selectDirectoryID"
              :disk="disk"
            />

            <SearchFile
              class="mt-gd-2"
              v-if="selectDirectoryType === 'system'"
              @callback="callback"
              @toggleMultiSelect="toggleMultiSelect"
              @clear="clearFile"
              @setDisplay="setDisplay"
              :limit="limit"
              :fileSelectedLength="fileSelected.length"
              :displayType="displayType"
              :filelistLength="filelist.length"
              :options="options"
            />

            <SearchUnsplash
              v-if="selectDirectoryType === 'unsplash'"
              @callback="getUnsplashPhoto"
              @clear="clearFile"
              :limit="limit"
              :options="optionsUnsplash"
            />
            <!-- <SearchFlaticon
              v-if="selectDirectoryType === 'flaticon' && !iconPack"
              @callback="getFlaticonPacks"
              @clear="clearFile"
              :limit="limit"
              :options="optionsFlaticonPacks"
            />
            <SearchIcon
              v-if="selectDirectoryType === 'icon'"
              @callback="getIcons"
              @clear="clearFile"
              :limit="limit"
              :options="optionsIcons"
            /> -->
            <div
              v-if="search && !loading && selectDirectoryType === 'system'"
              class="fs-dbb-16 pt-gd-1"
            >
              {{ $t('engine.common.searchResult',languageEngine) }} <span class="fs-sa-16">({{ fileTotalCount }})</span>
              <hr class="mt-0" />
            </div>

            <!-- <div
              v-if="search && selectDirectoryType === 'flaticon' && !iconPack"
              class="fs-dbb-16 pt-gd-1"
            >
              Search Results
              <hr class="mt-0 mb-2" />
            </div>
            <div
              v-if="search && selectDirectoryType === 'icon'"
              class="fs-dbb-16 pt-gd-1"
            >
              Search Results
              <hr class="mt-0 mb-2" />
            </div> -->
            <component
              :is="displayType"
              v-if="displayType && selectDirectoryType === 'system'"
              ref="FileList"
              @setFileHightLight="setFileHightLight"
              @setFileSelected="setFileSelected"
              @callback="callback"
              @cancelRequest="cancelRequest"
              :loading="loading"
              :selectDirectoryType="selectDirectoryType"
              :fileTotalCount="fileTotalCount"
              :filelist="filelist"
              :options="options"
              :fileHighlight="fileHighlight"
              :limit="limit"
            />
            <FileUnsplash
              v-if="selectDirectoryType === 'unsplash'"
              ref="FileList"
              @setFileHightLight="setFileHightLight"
              @setFileSelected="setFileSelected"
              @callback="getUnsplashPhoto"
              :loading="loading"
              :selectDirectoryType="selectDirectoryType"
              :fileTotalCount="fileTotalCount"
              :filelist="filelist"
              :options="optionsUnsplash"
              :fileHighlight="fileHighlight"
              :limit="limit"
              :isHasMoreFile="isHasMoreFile"
            />
            <!-- <FileFlaticonPacks
              v-if="selectDirectoryType === 'flaticon' && !search"
              ref="FileList"
              @setPackSelect="setPackSelect"
              @setFileHightLight="setFileHightLight"
              @setFileSelected="setFileSelected"
              :loading="loading"
              :filelist="filelist"
            />
            <FileFlaticonIcon
              v-if="selectDirectoryType === 'flaticon' && search && !loading"
              ref="FileList"
              @goToBack="getFlaticonPacks"
              @callback="goToPack"
              @setFileHightLight="setFileHightLight"
              @setFileSelected="setFileSelected"
              :loading="loading"
              :selectDirectoryType="selectDirectoryType"
              :fileTotalCount="fileTotalCount"
              :filelist="filelist"
              :fileHighlight="fileHighlight"
              :options="iconPack ? optionsFlaticonIcon : optionsFlaticonPacks"
              :limit="limit"
              :isHasMoreFile="isHasMoreFile"
              :iconPack="iconPack"
            />
            <FileIcon
              v-if="selectDirectoryType === 'icon'"
              ref="FileList"
              @setFileHightLight="setFileHightLight"
              @setFileSelected="setFileSelected"
              @callback="getIcons"
              :loading="loading"
              :selectDirectoryType="selectDirectoryType"
              :fileTotalCount="fileTotalCount"
              :filelist="filelist"
              :fileHighlight="fileHighlight"
              :options="optionsIcons"
              :limit="limit"
              :isHasMoreFile="isHasMoreFile"
            /> -->
          </Wrapper>
          <FileDetail
            v-if="selectDirectoryType === 'system'"
            :fileHighlight="fileHighlight"
          />

          <UploadAlert
            @goToFiles="goToFiles"
            @hasUpload="setHasUploadMain"
            @cancelRequest="cancelRequest"
            :hasUpload="hasUpload"
            :uploadedFiles="uploadedFiles"
            :countUpload="countUpload"
            :countUploadError="countUploadError"
            :fileUpload="fileUpload"
            :rerenderProgress="rerenderProgress"
            :selectDirectoryID="selectDirectoryID"
          />
        </div>
      </template>
      <template #modal-footer="{ close }">
        <SelectedFileImg
          style="height: 85px;"
          @addImg="addImage(close)"
          @clear="clearFileSelected"
          @setFileHightlight="fileHightLight"
          @loading="setLoading"
          @callback="callback"
          :fileHighlight="fileHighlight"
          :fileSelected="fileSelected"
          :selectDirectoryName="selectDirectoryName"
          :selectDirectoryID="selectDirectoryID"
          :selectDirectoryType="selectDirectoryType"
          :limit="limit"
        />
      </template>
    </b-modal>
    <ErrorDelete />
    <ConfirmCancelUpload @confirmed="cancelUploads()" />
    <DialogSizeLimit :space="disk.all" />
    <DialogSelectLimit :type="customid" :limit="limit" :select="selectCount" />
  </div>
</template>

<script>
import ErrorDelete from "./modal/ErrorDelete.vue";
import DialogSizeLimit from "./modal/DialogSizeLimit.vue";
import DialogSelectLimit from "./modal/DialogSelectLimit.vue";
import ConfirmCancelUpload from "./modal/ConfileCancelUpload.vue";
import { mapGetters } from "vuex";

import { Wrapper } from "./Filemanager.styled";
import fileService from "@services/fileService.js";

import CreateFolder from "./CreateFolder.vue";
import SystemDirectory from "./SystemDirectory.vue";
import ExternalDirectory from "./ExternalDirectory.vue";
import UploadArea from "./UploadArea.vue";
import UploadAlert from "./UploadAlert.vue";
import FileDetail from "./FileDetail.vue";
import SearchFile from "./SearchFile.vue";
import SelectedFileImg from "./SelectedFile.vue";
import SearchUnsplash from "./SearchUnsplash.vue";
import FileUnsplash from "./FileUnsplash.vue";
// import SearchFlaticon from "./SearchFlaticon.vue";
// import SearchIcon from "./SearchIcon.vue";
// import FileFlaticonPacks from "./FileFlaticonPacks.vue";
// import FileFlaticonIcon from "./FileFlaticonIcon.vue";
// import FileIcon from "./FileIcon.vue";
import { imageMapping } from "@model/components/imageCrop.model";
import setObjectPath from "@helpers/setObjectPath.helper";
import {
  checkDimensionFile
} from "@helpers/imageCrop.helper";

const component = {
  list: () => import(/* webpackChunkName: "list" */ "./FileList.vue"),
  thumbnail: () => import(/* webpackChunkName: "thumbnail" */ "./FileGrid.vue"),
};

export default {
  components: {
    Wrapper,
    ErrorDelete,
    DialogSizeLimit,
    DialogSelectLimit,
    ConfirmCancelUpload,

    CreateFolder,
    SystemDirectory,
    ExternalDirectory,
    UploadArea,
    UploadAlert,
    FileDetail,
    SearchFile,
    SelectedFileImg,
    SearchUnsplash,
    FileUnsplash,
    // SearchFlaticon,
    // SearchIcon,
    // FileFlaticonPacks,
    // FileFlaticonIcon,
    // FileIcon,
    ...component,
  },
  computed: {
    ...mapGetters({
      modals: "design/modals/modals",
      modalActive: "design/modals/modalActive",
      components: "design/metadata/components",
      siteComponents: "design/metadata/siteComponents",
      languageEngine: "design/userPreference/languageEngine",
    }),
    selectCount() {
      return this.fileSelected.length;
    },
    modal() {
      return this.modals[this.modalID]
    },
  },
  data() {
    return {
      modalID: "modal-filemanager",
      onChange: () => {},
      componentConfig: undefined,
      loading: false,
      loadingGetSysDir: false,
      search: false,
      selectDirectoryType: "system",
      selectDirectoryID: undefined,
      selectDirectoryName: undefined,
      fileHighlight: undefined,
      fileSelected: [],
      filelist: [],
      fileTotalCount: 0,
      siteFileDirectory: [],
      defaultDirectory: {},
      fileUpload: [],
      uploadedFiles: 0,
      countUpload: 0,
      countUploadError: 0,
      hasUpload: false,
      visible: true,
      cancelTokens: [],
      rerenderProgress: true,
      displayType: "thumbnail",
      limit: 1,
      isShowDocument: false,
      isShowImage: true,
      isShowUnsplash: true,
      isShowFlaticon: true,
      isShowIcon: true,
      isHasMoreFile: true,
      iconPack: undefined,
      isDefaultUrl: false,
      disk: {
        package: "Unlimited",
        all: 99999,
        used: 0,
      },
      options: {
        p: 1,
        take: 50,
        name: "",
      },
      optionsUnsplash: {
        p: 1,
        take: 30,
        name: "",
        categoryID: 0,
      },
      optionsUnsplashTemp: {
        p: 1,
        take: 30,
        name: "",
        categoryID: 0,
      },
      optionsFlaticonPacks: {
        name: "",
        style: "all",
        p: 1,
        take: 50,
      },
      optionsFlaticonPacksTemp: {
        name: "",
        style: "all",
        p: 1,
        take: 50,
      },
      optionsFlaticonIcon: {
        p: 1,
        take: 20,
      },
      optionsIcons: {
        categoryID : 'all',
        text : '',
        p: 0,
        take: 50,
      },
      optionsIconsTemp: {
        categoryID : 'all',
        text : '',
        p: 0,
        take: 50,
      },
    };
  },
  methods: {
    onModalHidden() {
      this.$store.dispatch("designIframe/modals/callback", {
        key: this.modalID,
        clear: true,
        func: 'onClose',
        data: {}
      },{ root:true });
    },
    async addImage(close) {
      if (this.selectDirectoryType === "unsplash") {
        this.$store.dispatch('design/blockloading')
        await this.importUnsplash();
        await this.$store.dispatch('design/page/initImagesID')
        this.$store.dispatch('design/unblockloading')
      }
      if (this.onChange) {
        if (this.selectDirectoryType === "unsplash") {
          this.loading = true;
          this.onChange(this.fileSelected);
          close();
          this.$store.dispatch("design/snapshot/genSnapshot");
          // let data = [];
          // this.fileSelected.map((img) => {
          //   data.push({
          //     id: img.id,
          //     download: img.links.download,
          //     raw: img.urls.raw,
          //   });
          // });
          // fileService
          //   .importUnsplash({ files: data })
          //   .then((result) => {
          //     this.loading = false;
          //     let data = [];
          //     result.map((img) => {
          //       data.push({ ...img, type: "unsplash" });
          //     });
          //     this.onChange(data);
          //     close();
          //     this.$store.dispatch("design/snapshot/genSnapshot");
          //   })
          //   .catch(() => {
          //     this.$bvModal.show("modal-limit");
          //     this.loading = false;
          //   });
        } else if (this.selectDirectoryType === "flaticon") {
          this.loading = true;
          const id = this.fileSelected[0].id;
          const data = {
            name: this.fileSelected[0].name,
            url: this.fileSelected[0].url,
          };
          fileService
            .importFlaticon(id, data)
            .then((result) => {
              this.loading = false;
              const data = {
                ...result,
                type: "flaticon",
              };
              this.onChange(data);
              close();
              this.$store.dispatch("design/snapshot/genSnapshot");
            })
            .catch(() => {
              this.$bvModal.show("modal-limit");
              this.loading = false;
            });
        } else if (this.selectDirectoryType === "icon") {
          this.loading = true;
          const id = this.fileSelected[0].id;
          fileService
            .importIcon(id)
            .then((result) => {
              this.loading = false;
              const data = {
                ...result,
                type: "icon",
              };
              this.onChange(data);
              close();
              this.$store.dispatch("design/snapshot/genSnapshot");
            })
            .catch(() => {
              this.$bvModal.show("modal-limit");
              this.loading = false;
            });
          } else {
          this.onChange(this.fileSelected);
          close();
          this.$store.dispatch("design/snapshot/genSnapshot");
        }
      } else if (this.componentConfig) {
        if (this.componentConfig.type === "flaticon" && this.selectDirectoryType === "flaticon") {
          //
          //
          this.loading = true;
          const id = this.fileSelected[0].id;
          const data = {
            name: this.fileSelected[0].name,
            url: this.fileSelected[0].url,
          };
          fileService
            .importFlaticon(id, data)
            .then((result) => {
              this.loading = false;
              const data = {
                ...result,
                type: "flaticon",
              };

              this.$store.dispatch("designIframe/texteditor/getIcon", {
                changeIcon: this.componentConfig.changeIcon,
                selection: this.componentConfig.selection,
                data: data,
              });
              close();
              this.$store.dispatch("design/snapshot/genSnapshot");
            })
            .catch(() => {
              this.$bvModal.show("modal-limit");
              this.loading = false;
            });
        } else if (this.componentConfig.type === "flaticon" && this.selectDirectoryType === "icon") {
          this.loading = true;
          const id = this.fileSelected[0].id;
          fileService
            .importIcon(id)
            .then((result) => {
              this.loading = false;
              const data = {
                ...result,
                type: "icon",
              };

              this.$store.dispatch("designIframe/texteditor/getIcon", {
                changeIcon: this.componentConfig.changeIcon,
                selection: this.componentConfig.selection,
                data: data,
              });
              close();
              this.$store.dispatch("design/snapshot/genSnapshot");
            })
            .catch(() => {
              this.$bvModal.show("modal-limit");
              this.loading = false;
            });
        } else if (this.componentConfig.type === "texteditor-icon") {
          this.loading = true;
          const id = this.fileSelected[0].id;
          fileService.importIcon(id).then((result) => {
            this.loading = false;
            const data = {
              ...result,
              type: "icon",
            };
            this.$store.dispatch("designIframe/modals/callback", {
              key: this.modalID,
              clear: false,
              func: 'onSubmit',
              data: {
                changeIcon: this.componentConfig.changeIcon,
                selection: this.componentConfig.selection,
                data: data,
              },
            },{ root:true });
            close();
          }).catch(() => {
            this.$bvModal.show("modal-limit");
            this.loading = false;
          });
        } else if (this.componentConfig.type === "texteditor-image") {
          this.loading = true;
          const file = this.fileSelected[0];
          this.$store.dispatch("designIframe/modals/callback", {
            key: this.modalID,
            clear: false,
            func: 'onSubmit',
            data: {
              file: file,
            },
          },{ root:true });
          this.loading = false;
          setTimeout(() => {
            close();
          }, 500);
        } else if (this.componentConfig.type === "widget-icon" && this.selectDirectoryType === "flaticon") {
          this.loading = true;
          const id = this.fileSelected[0].id;
          const data = {
            name: this.fileSelected[0].name,
            url: this.fileSelected[0].url,
          };
          const component = this.components[this.componentConfig.id];
          fileService
            .importFlaticon(id, data)
            .then((result) => {
              this.loading = false;
              const data = {
                ...result,
                source: "flaticon",
              };
              setObjectPath(component, data.id, `/data/iconID`);
              setObjectPath(component, data.content, `/data/iconContent`);
              setObjectPath(component, null, `/style/iconColor`);
              close();
              this.$store.dispatch("design/snapshot/genSnapshot");
            })
            .catch(() => {
              this.$bvModal.show("modal-limit");
              this.loading = false;
            });
        } else if (this.componentConfig.type === "widget-icon" && this.selectDirectoryType === "icon") {
          this.loading = true;
          const id = this.fileSelected[0].id;
          const component = this.components[this.componentConfig.id];
          fileService
            .importIcon(id)
            .then((result) => {
              this.loading = false;
              const data = {
                ...result,
                type: "icon",
              };
              setObjectPath(component, data.id, `/data/iconID`);
              setObjectPath(component, data.content, `/data/iconContent`);
              setObjectPath(component, null, `/style/iconColor`);
              close();
              this.$store.dispatch("design/snapshot/genSnapshot");
            })
            .catch(() => {
              this.$bvModal.show("modal-limit");
              this.loading = false;
            });
        } else if (this.componentConfig.type === "widget-image-gallery") {
          if(this.componentConfig.action == 'add') {
            this.$store.dispatch("designIframe/modals/callback", {
              key: this.modalID,
              clear: false,
              func: 'onAddImage',
              data: {
                files : this.fileSelected
              },
            },{ root:true });
            close();
          }else {
           this.$store.dispatch("designIframe/modals/callback", {
              key: this.modalID,
              clear: false,
              func: 'onChangeImage',
              data: {
                files : this.fileSelected
              },
            },{ root:true });
            close();
          }
        } else if (this.componentConfig.type === "slide-item") {
          this.loading = true;
          const data = this.fileSelected[0];
          const component = this.components[this.componentConfig.id];
          setObjectPath(component, data.alt, `/data/imageAlt`);
          setObjectPath(component, data.id, `/data/imageID`);
          setObjectPath(component, data.name, `/data/imageName`);
          setObjectPath(component, data.title, `/data/imageTitle`);
          setObjectPath(component, data.type, `/data/imageType`);
          setObjectPath(component, data.url, `/data/imageUrl`);
          this.loading = false;
          close();
          this.$store.dispatch("design/snapshot/genSnapshot");
        } else if (this.componentConfig.type === "slide-page") {
          this.loading = true;
          const data = this.fileSelected[0];
          const component = this.components[this.componentConfig.id];
          setObjectPath(component, data.url, `/style/backgroundImageUrl`);
          setObjectPath(component, data.width, `/style/backgroundImageWidth`);
          setObjectPath(component, data.height, `/style/backgroundImageHeight`);
          setObjectPath(component, data.alt, `/style/backgroundImageAlt`);
          setObjectPath(component, data.id, `/style/backgroundImageID`);
          setObjectPath(component, data.name, `/style/backgroundImageName`);
          setObjectPath(component, data.title, `/style/backgroundImageTitle`);
          setObjectPath(component, data.type, `/style/backgroundImageType`);
          setObjectPath(component, 0, `/style/backgroundImageCropPosX`);
          setObjectPath(component, 0, `/style/backgroundImageCropPosY`);
          setObjectPath(component, data.width, `/style/backgroundImageCropWidth`);
          setObjectPath(component, data.height, `/style/backgroundImageCropHeight`);
          setObjectPath(component, 'image', `/style/backgroundType`);
          this.loading = false;

          close();
          this.$store.dispatch("design/snapshot/genSnapshot");
        } else if (this.componentConfig.type === "header-widget-logo") {
          const component = this.siteComponents[this.componentConfig.id];
          const file = this.fileSelected[0];
          setObjectPath(component, file.id, `/data/imageID`);
          setObjectPath(component, file.type, `/data/imageType`);
          setObjectPath(component, file.url, `/data/imageUrl`);
          setObjectPath(component, file.alt, `/data/imageAlt`);
          setObjectPath(component, file.name, `/data/imageName`);
          setObjectPath(component, file.title, `/data/imageTitle`);
          setObjectPath(component, file.width, `/data/imageWidth`);
          setObjectPath(component, file.height, `/data/imageHeight`);
          const headerLayout = this.siteComponents.HEADER.style.layout
          let styleImageWidth
          let styleImageHeight
          if (headerLayout == "02" || headerLayout == "04" || headerLayout == "05") {
            if (file.height <= 400 && file.width <= 600) {
              styleImageWidth = file.width;
              styleImageHeight = file.height;
            } else if (file.width > 600) {
              let Ratio = file.width / file.height;
              styleImageWidth = 600;
              styleImageHeight = Math.round(600 / Ratio);
              if (styleImageHeight > 400) {
                styleImageHeight = 400
                styleImageWidth = Math.round(400 * Ratio);
              }
            } else {
              let Ratio = file.height / file.width;
              styleImageHeight = 400;
              styleImageWidth = Math.round(400 / Ratio);
              if (styleImageWidth > 600) {
                styleImageWidth = 600
                styleImageHeight = Math.round(600 * Ratio);
              }
            }
          } else {
            if (file.height <= 200 && file.width <= 400) {
              styleImageWidth = file.width;
              styleImageHeight = file.height;
            } else if (file.width > 400) {
              let Ratio = file.width / file.height;
              styleImageWidth = 400;
              styleImageHeight = Math.round(400 / Ratio);
              if (styleImageHeight > 200) {
                styleImageHeight = 200
                styleImageWidth = Math.round(200 * Ratio);
              }
            } else {
              let Ratio = file.height / file.width;
              styleImageHeight = 200;
              styleImageWidth = Math.round(200 / Ratio);
              if (styleImageWidth > 400) {
                styleImageWidth = 400
                styleImageHeight = Math.round(400 * Ratio);
              }
            }
          }
          setObjectPath(component, styleImageWidth, `/style/imageWidth`);
          setObjectPath(component, styleImageHeight, `/style/imageHeight`);
          this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine), message: this.$t('engine.common.alert.upload.success', this.languageEngine) });
          close();
          this.$store.dispatch("design/snapshot/genSnapshot");
        } else if (this.componentConfig.type === "footer-widget-logo"){
          const component = this.siteComponents[this.componentConfig.id];
          const file = this.fileSelected[0];
          setObjectPath(component, file.id, `/data/imageID`);
          setObjectPath(component, file.type, `/data/imageType`);
          setObjectPath(component, file.url, `/data/imageUrl`);
          setObjectPath(component, file.alt, `/data/imageAlt`);
          setObjectPath(component, file.name, `/data/imageName`);
          setObjectPath(component, file.title, `/data/imageTitle`);
          setObjectPath(component, file.width, `/data/imageWidth`);
          setObjectPath(component, file.height, `/data/imageHeight`);
          const footerLayout = this.siteComponents.FOOTER.style.layout
          let styleImageWidth
          let styleImageHeight
            if(footerLayout === '03' || footerLayout === '04'){
                if (file.width <= 345 && file.height <= 230) {
                    styleImageWidth = file.width;
                    styleImageHeight = file.height;
                } else if (file.width > 345 ) {
                    let Ratio = file.width / file.height;
                    styleImageWidth = 345;
                    styleImageHeight = Math.round(345 / Ratio);
                      if (styleImageHeight > 230) {
                        styleImageWidth = Math.round(230 * Ratio);
                        styleImageHeight = 230
                      }
                } else {
                    let Ratio = file.height / file.width;
                    styleImageWidth = Math.round(230 / Ratio);
                    styleImageHeight = 230;
                      if (styleImageWidth > 345) {
                        styleImageWidth = 345;
                        styleImageHeight = Math.round(345 * Ratio);
                      }
                }
            }else if(footerLayout === '02'){
                if (file.width <= 600 && file.height <= 400) {
                    styleImageWidth = file.width;
                    styleImageHeight = file.height;
                } else if (file.width > 600 ) {
                    let Ratio = file.width / file.height;
                    styleImageWidth = 600;
                    styleImageHeight = Math.round(600 / Ratio);
                      if (styleImageHeight > 400) {
                        styleImageWidth = Math.round(400 * Ratio);
                        styleImageHeight = 400
                      }
                } else {
                    let Ratio = file.height / file.width;
                    styleImageWidth = Math.round(400 / Ratio);
                    styleImageHeight = 400;
                      if (styleImageWidth > 345) {
                        styleImageWidth = 600;
                        styleImageHeight = Math.round(600 * Ratio);
                      }
                }
            }else {
                if (file.width <= 255 && file.height <= 170) {
                    styleImageWidth = file.width;
                    styleImageHeight = file.height;
                } else if (file.width > 255 ) {
                    let Ratio = file.width / file.height;
                    styleImageWidth = 255;
                    styleImageHeight = Math.round(255 / Ratio);
                      if (styleImageHeight > 170) {
                        styleImageWidth = Math.round(170 * Ratio);
                        styleImageHeight = 170
                      }
                } else {
                    let Ratio = file.height / file.width;
                    styleImageWidth = Math.round(170 / Ratio);
                    styleImageHeight = 170;
                      if (styleImageWidth > 255) {
                        styleImageWidth = 255;
                        styleImageHeight = Math.round(255 * Ratio);
                      }
                }
          }
          setObjectPath(component, styleImageWidth, `/style/width`);
          setObjectPath(component, styleImageHeight, `/style/height`);
          close();
          this.$store.dispatch("design/snapshot/genSnapshot");
        } else if (this.componentConfig.type === "widget-youtube") {
          const component = this.components[this.componentConfig.id];
          const file = this.fileSelected[0];
          const mapping = imageMapping(component.type);
          
          if (mapping) {
            const imageWidth = file.width;
            const imageHeight = file.height;

            setObjectPath(component, file.id, `/${mapping.imageId}`);
            setObjectPath(component, file.url, `/${mapping.imageUrl}`);
            setObjectPath(component, 100, `/${mapping.cropZoomPct}`);

            const imageRatio = imageWidth / imageHeight;
            const cropRatio = component.style.width / component.style.height;

            if (imageRatio == cropRatio) {
              setObjectPath(component, imageWidth, `/${mapping.cropWidth}`);
              setObjectPath(component, imageHeight, `/${mapping.cropHeight}`);
              setObjectPath(component, 0, `/${mapping.cropPosX}`);
              setObjectPath(component, 0, `/${mapping.cropPosY}`);
            } else if (imageRatio > cropRatio) {
              const newCropWidth = Math.round(
                (imageHeight * component.style.width) / component.style.height
              );
              const PosX = Math.round((imageWidth - newCropWidth) / 2);
              setObjectPath(component, newCropWidth, `/${mapping.cropWidth}`);
              setObjectPath(component, imageHeight, `/${mapping.cropHeight}`);
              setObjectPath(component, PosX, `/${mapping.cropPosX}`);
              setObjectPath(component, 0, `/${mapping.cropPosY}`);
            } else if (imageRatio < cropRatio) {
              const newCropHeight = Math.round(
                (imageWidth * component.style.height) / component.style.width
              );
              const PosY = Math.round((imageHeight - newCropHeight) / 2);
              setObjectPath(component, imageWidth, `/${mapping.cropWidth}`);
              setObjectPath(component, newCropHeight, `/${mapping.cropHeight}`);
              setObjectPath(component, 0, `/${mapping.cropPosX}`);
              setObjectPath(component, PosY, `/${mapping.cropPosY}`);
            }
          }
          close();
          this.$store.dispatch("design/snapshot/genSnapshot");
        } else {
          const component = this.components[this.componentConfig.id];
          const file = this.fileSelected[0];
          const mapping = imageMapping(component.type);
          let width = 0
          let height = 0

          if (mapping) {
            if(!file.width || !file.height){
              const dimensionFile =  await checkDimensionFile(file.url)
              width = dimensionFile.width;
              height = dimensionFile.height;
            }else{
              width = file.width;
              height = file.height;
            }
            const imageWidth = width;
            const imageHeight = height;


            setObjectPath(component, file.id, `/${mapping.imageId}`);
            setObjectPath(component, file.url, `/${mapping.imageUrl}`);
            setObjectPath(component, file.name, `/${mapping.imageName}`);
            setObjectPath(component, file.alt, `/${mapping.imageAlt}`);
            setObjectPath(component, file.title, `/${mapping.imageTitle}`);
            setObjectPath(component, file.type, `/${mapping.imageType}`);
            setObjectPath(component, imageWidth, `/${mapping.imageWidth}`);
            setObjectPath(component, imageHeight, `/${mapping.imageHeight}`);
            setObjectPath(component, 100, `/${mapping.cropZoomPct}`);

            const imageRatio = imageWidth / imageHeight;
            const cropRatio = component.style.width / component.style.height;

            if (imageRatio == cropRatio) {
              setObjectPath(component, imageWidth, `/${mapping.cropWidth}`);
              setObjectPath(component, imageHeight, `/${mapping.cropHeight}`);
              setObjectPath(component, 0, `/${mapping.cropPosX}`);
              setObjectPath(component, 0, `/${mapping.cropPosY}`);
            } else if (imageRatio > cropRatio) {
              const newCropWidth = Math.round(
                (imageHeight * component.style.width) / component.style.height
              );
              const PosX = Math.round((imageWidth - newCropWidth) / 2);
              setObjectPath(component, newCropWidth, `/${mapping.cropWidth}`);
              setObjectPath(component, imageHeight, `/${mapping.cropHeight}`);
              setObjectPath(component, PosX, `/${mapping.cropPosX}`);
              setObjectPath(component, 0, `/${mapping.cropPosY}`);
            } else if (imageRatio < cropRatio) {
              const newCropHeight = Math.round(
                (imageWidth * component.style.height) / component.style.width
              );
              const PosY = Math.round((imageHeight - newCropHeight) / 2);
              setObjectPath(component, imageWidth, `/${mapping.cropWidth}`);
              setObjectPath(component, newCropHeight, `/${mapping.cropHeight}`);
              setObjectPath(component, 0, `/${mapping.cropPosX}`);
              setObjectPath(component, PosY, `/${mapping.cropPosY}`);
            }
          }
          close();
          this.$store.dispatch("design/snapshot/genSnapshot");
        }
      }
    },
    importFlatIcon() {
      this.loading = true;
      let newData = [];
      this.fileSelected.map((file) => {
        const id = file.id;
        const data = {
          name: file[0].name,
          url: file[0].url,
        };
        fileService.importFlaticon(id, data).then((result) => {
          this.loading = false;
          newData.push({ ...result, type: "flaticon" });
        }).catch(() => {
          this.$bvModal.show("modal-limit");
          this.loading = false;
        });
      });
    },
    async importUnsplash() {
      let data = [];
      let newData = [];
      this.fileSelected.map((img) => {
        data.push({
          id: img.id,
          download: img.links.download,
          raw: img.urls.raw,
        });
      });
      await fileService.importUnsplash({ files: data }).then((result) => {
        this.loading = false;
        result.map((img) => {
          newData.push({ ...img, type: "website" });
        });
        this.fileSelected = newData;
      }).catch(() => {
        this.$bvModal.show("modal-limit");
        this.loading = false;
      });
    },
    checkDisk() {
      fileService.getDisklUsed().then((result) => {
        this.disk = result.space;
      });
    },
    setFileHightLight(value) {
      this.fileHighlight = value;
    },
    setFileSelected(value) {
      this.fileSelected = value;
    },
    toggleMultiSelect() {
      this.$refs.FileList.toggleMultiSelect();
    },
    clearFile() {
      this.$refs.FileList && this.$refs.FileList.clearFile();
    },
    clearFileSelected() {
      this.$refs.FileList && this.$refs.FileList.clearFileSelected();
    },
    fileHightLight(value) {
      this.$refs.FileList.setFileHighLight(value);
    },
    setFileSelectedMain(value, clear = false) {
      this.$refs.FileList.setFileSelected(value, clear);
    },
    callback(value = {}) {
      if (Object.keys(value).length > 0) {
        this.selectDirectoryID = value.id;
        this.selectDirectoryName = value.name;
      }
      if (this.selectDirectoryType !== "system") {
        this.filelist = [];
        this.clearFilter();
      }
      this.getSystemFiles(this.selectDirectoryID, this.selectDirectoryName);
    },
    getDisplay() {
      fileService.getDisplay().then((result) => {
        this.displayType = result.displayType;
      });
    },
    getSystemFiles(directoryID, directoryName) {
      this.selectDirectoryType = "system";
      this.loading = true;
      this.selectDirectoryID = directoryID;
      this.selectDirectoryName = directoryName;
      this.search = false;
      this.uploadedFiles !== Math.abs(this.countUpload - this.countUploadError)
        ? this.$bvModal.hide("modal-confirm-cancel")
        : false;
      fileService.getFiles(directoryID, this.options).then((result) => {
        if (this.options.name !== "") {
          this.search = true;
        }
        this.filelist = result.files;
        this.checkDimensionFile();
        this.fileTotalCount = result.totalCount;
        this.loading = false;
      });
    },
    checkDimensionFile() {
      this.filelist.map((file) => {
        if (!file.width || !file.height) {
          this.getMeta(
            file.url.replace("{{size}}", 0),
            function (width, height) {
              fileService.updateFileDimension(file.id, { width, height });
            }
          );
        }
      });
    },
    getMeta(url, callback) {
      var img = new Image();
      img.src = url;
      img.onload = function () {
        callback(this.width, this.height);
      };
    },
    callbackdir(value) {
      this.selectDirectoryID = value.id;
      this.selectDirectoryName = value.name;
      this.getSystemFiles(this.selectDirectoryID, this.selectDirectoryName);
      this.getSystemDirectories(false);
    },
    getSystemDirectories(request = true) {
      this.loading = true;
      this.loadingGetSysDir = true;
      this.selectDirectoryType = "system";
      fileService.getDirectories().then((result) => {
        this.defaultDirectory = result.defaultDirectory;

        if (request) {
          let id = result.defaultDirectory.id;
          let name = result.defaultDirectory.name;
          if (this.isShowDocument && !this.isShowImage) {
            id = "document";
            name = "Document";
          }
          this.getSystemFiles(id, name);
        }
        this.siteFileDirectory = result.directories;
        this.loading = false;
        this.loadingGetSysDir = false;
      });
    },
    getUnsplashPhoto() {
      const checkFilter =
        this.optionsUnsplashTemp.categoryID !==
          this.optionsUnsplash.categoryID ||
        this.optionsUnsplashTemp.name !== this.optionsUnsplash.name;
      if (this.selectDirectoryType !== "unsplash") {
        this.clearFilter();
        this.filelist = [];
      }
      if (this.isDefaultUrl && checkFilter) {
        this.getDefaultUnsplash(checkFilter);
        return;
      }
      this.selectDirectoryID = "unsplash";
      this.selectDirectoryName = "Unsplash";
      this.selectDirectoryType = "unsplash";
      this.isHasMoreFile = true;
      let options = { ...JSON.parse(JSON.stringify(this.optionsUnsplash)) };
      fileService
        .getUnsplash(options)
        .then((result) => {
          if (this.optionsUnsplash.name !== "") {
            this.search = true;
          }
          if (checkFilter) {
            this.filelist = result.data;
            this.fileTotalCount = result.data.length;
            this.optionsUnsplashTemp.name = this.optionsUnsplash.name;
            this.optionsUnsplashTemp.categoryID =
              this.optionsUnsplash.categoryID;
            this.clearFile();
            // if(result.data.length === 0) {
            //   this.resetOptionsUnsplash();
            //   this.getDefaultUnsplash(checkFilter);
            //   this.isDefaultUrl = true;
            //   return;
            // }
          } else {
            this.filelist.push(...result.data);
            this.fileTotalCount = +result.data.length;
          }
          if (result.data.length === 0) {
            this.isHasMoreFile = false;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getDefaultUnsplash(checkFilter) {
      fileService
        .getUnsplashDefault(this.optionsUnsplash)
        .then((result) => {
          if (this.optionsUnsplash.name !== "") {
            this.search = true;
          }
          if (checkFilter) {
            this.filelist = result.data;
            this.fileTotalCount = result.data.length;
            this.clearFile();
          } else {
            this.filelist.push(...result.data);
            this.fileTotalCount = +result.data.length;
          }
          if (result.data.length === 0) {
            this.isDefaultUrl = false;
            this.isHasMoreFile = false;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.getDefaultUnsplash();
        });
    },
    getFlaticonPacks() {
      const filterChange =
        this.optionsFlaticonPacksTemp.style !==
          this.optionsFlaticonPacks.style ||
        this.optionsFlaticonPacksTemp.name !== this.optionsFlaticonPacks.name;
      if (filterChange) {
        this.optionsFlaticonPacks.p = 1;
      }
      if (this.selectDirectoryType !== "flaticon" || !!this.iconPack) {
        this.clearFilter();
        this.filelist = [];
        this.selectDirectoryID = "flaticon";
        this.selectDirectoryName = "Flaticon";
        this.selectDirectoryType = "flaticon";
      }
      this.iconPack = undefined;
      this.loading = filterChange;
      this.search = false;
      this.isHasMoreFile = true;
      let options = {
        ...JSON.parse(JSON.stringify(this.optionsFlaticonPacks)),
      };
      if (this.optionsFlaticonPacks.name !== "") {
        this.search = true;
        this.getFlaticonIcons(options);
      } else {
        this.getIconPacks(options);
      }
    },
    getFlaticonIcons(options) {
      fileService
        .getFlaticonIcons(options)
        .then((result) => {
          if (
            this.optionsFlaticonPacksTemp.style !==
              this.optionsFlaticonPacks.style ||
            this.optionsFlaticonPacksTemp.name !==
              this.optionsFlaticonPacks.name
          ) {
            this.filelist = result.data;
            this.fileTotalCount = result.data.length;
            this.optionsFlaticonPacksTemp.name = this.optionsFlaticonPacks.name;
            this.optionsFlaticonPacksTemp.style =
              this.optionsFlaticonPacks.style;
            this.clearFile();
          } else {
            this.filelist.push(...result.data);
            this.fileTotalCount = +result.data.length;
          }
          if (result.data.length === 0) {
            this.isHasMoreFile = false;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.isHasMoreFile = false;
          this.filelist = [];
        });
    },
    getIconPacks(options) {
      fileService
        .getFlaticonPacks(options)
        .then((result) => {
          this.filelist = result.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.isHasMoreFile = false;
          this.filelist = [];
        });
    },
    setPackSelect(value) {
      this.iconPack = value;
      this.filelist = [];
      this.goToPack();
    },
    getIcons() {
      if (this.selectDirectoryType !== "icon") {
        this.clearFilter();
        this.filelist = [];
      }
      this.selectDirectoryType = "icon";
      this.selectDirectoryID = "icon";
      let options = {
        ...JSON.parse(JSON.stringify(this.optionsIcons)),
      };
      fileService
        .getIcons(options)
        .then((result) => {
          if(this.optionsIconsTemp.text !== this.optionsIcons.text ||
            this.optionsIconsTemp.categoryID !== this.optionsIcons.categoryID ||
            this.optionsIconsTemp.colorID !== this.optionsIcons.colorID){
            this.search = true;
            this.filelist = result.data;
            this.fileTotalCount = result.data.length;
            this.optionsIconsTemp.text = this.optionsIcons.text;
            this.optionsIconsTemp.categoryID = this.optionsIcons.categoryID;
            this.optionsIconsTemp.colorID = this.optionsIcons.colorID;
            this.optionsIconsTemp.p = this.optionsIcons.p
            this.optionsIconsTemp.take = this.optionsIcons.take
            this.clearFile();
          }else{
            this.search = false;
            this.filelist.push(...result.data);
            this.fileTotalCount = +result.data.length;
          }
          if (result.data.length === 0) {
            this.isHasMoreFile = false;
            this.optionsIcons.p = 0
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.isHasMoreFile = false;
          this.filelist = [];
        });
    },
    goToPack() {
      this.isHasMoreFile = true;
      this.search = true;
      fileService
        .getFlaticonPack(this.iconPack.id, this.optionsFlaticonIcon)
        .then((result) => {
          this.filelist.push(...result.data);
          this.fileTotalCount = +result.data.length;
          if (result.data.length === 0) {
            this.isHasMoreFile = false;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.isHasMoreFile = false;
          this.filelist = [];
        });
    },
    clearFilter() {
      this.clearFile();
      this.resetOptionsUnsplash();
      this.resetOptionsFlashicon();
      this.resetOptionsIcon();
      this.resetOptions();
    },
    resetOptions() {
      this.options = {
        p: 1,
        take: 50,
        name: "",
      };
    },
    resetOptionsUnsplash() {
      this.optionsUnsplash = {
        p: 1,
        take: 30,
        name: "",
        categoryID: 0,
      };
      this.optionsUnsplashTemp = {
        p: 1,
        take: 30,
        name: "",
        categoryID: 0,
      };
      this.isHasMoreFile = true;
    },
    resetOptionsFlashicon() {
      this.optionsFlaticonPacks = {
        name: "",
        style: "all",
        p: 1,
        take: 50,
      };
      this.optionsFlaticonPacksTemp = {
        name: "",
        style: "all",
        p: 1,
        take: 50,
      };
      this.isHasMoreFile = true;
    },
    resetOptionsIcon() {
      this.optionsIcons = {
        categoryID : 'all',
        colorID : 'all',
        text:'',
        p: 0,
        take: 50,
      };
      this.optionsIconsTemp = {
        categoryID : 'all',
        colorID : 'all',
        text:'',
        p: 0,
        take: 50,
      };
    },
    init({
      onChange,
      componentConfig,
      selectDirectoryType = "system",
      fileHighlight,
      fileSelected = [],
      limit = 1,
      isShowDocument = false,
      isShowImage = true,
      isShowUnsplash = true,
      isShowFlaticon = true,
      isShowIcon = true,
    }) {
      this.onChange = onChange;
      this.limit = limit;
      this.isShowDocument = isShowDocument;
      this.isShowImage = isShowImage;
      this.isShowUnsplash = isShowUnsplash;
      this.isShowFlaticon = isShowFlaticon;
      this.isShowIcon = isShowIcon;
      this.getDisplay();
      this.componentConfig = componentConfig;
      this.selectDirectoryType = selectDirectoryType;
      this.resetOptions();
      this.resetOptionsUnsplash();
      this.search = false;
      this.fileHighlight = fileHighlight;
      this.visible = true;
      this.hasUpload = false;
      this.fileSelected = fileSelected;
      this.checkDisk();
      this.$refs.filemanager.show();
      if (this.isShowDocument && !this.isShowImage) {
        this.selectDirectoryID = "document";
        this.selectDirectoryName = "Document";
        this.getSystemDirectories();
      } else if (
        !this.isShowDocument &&
        !this.isShowImage &&
        !isShowFlaticon &&
        !isShowIcon &&
        isShowUnsplash
      ) {
        this.selectDirectoryType = "unsplash";
        this.getUnsplashPhoto();
      } else if (
        !this.isShowDocument &&
        !this.isShowImage &&
        !isShowUnsplash &&
        isShowIcon &&
        isShowFlaticon
      ) {
        this.selectDirectoryType = "flaticon";
        this.getFlaticonPacks();
      } else if (
        !this.isShowDocument &&
        !this.isShowImage &&
        !isShowUnsplash &&
        !isShowIcon &&
        isShowFlaticon
      ) {
        this.selectDirectoryType = "flaticon";
        this.getFlaticonPacks();
      }  else if (
        !this.isShowDocument &&
        !this.isShowImage &&
        !isShowUnsplash &&
        !isShowFlaticon &&
        isShowIcon
      ){
        this.selectDirectoryType = "icon";
        this.getIcons();
      }else {
        this.getSystemDirectories();
      }
    },
    setCountUpload(value) {
      this.countUpload = value;
    },
    setCountUploadError(value) {
      this.countUploadError = value;
    },
    setFileUpload(value) {
      if(Math.abs(this.countUpload - this.countUploadError) != this.uploadedFiles) {
        this.fileUpload = [...this.fileUpload,...value];
      }else {
        this.fileUpload = value;
      }
    },
    setRerenderProgress(value) {
      this.rerenderProgress = value;
    },
    setUploadedFiles(value) {
      this.uploadedFiles = value;
    },
    setHasUpload(value) {
      this.hasUpload = value;
    },
    setHasUploadMain(value) {
      this.$refs.UploadArea.setHasUpload(value);
    },
    setLoading(value) {
      this.loading = value;
    },
    async goToFiles(file) {
      if (file.error) return;
      if (this.selectDirectoryID !== file.dictoryID || this.options.p !== 1) {
        this.resetOptions();
        this.loading = true;
        await this.getSystemFiles();
      }
      const filtered = this.filelist.filter((item) => file.id === item.id);
      if (filtered.length > 0) {
        this.fileHightLight(filtered[0]);
        this.setFileSelectedMain(filtered[0], true);
      }
    },
    cancelUploads() {
      this.$refs.UploadArea.cancelUploads();
    },
    cancelRequest(index) {
      this.$refs.UploadArea.cancelRequest(index);
    },
    setDisplay(value) {
      this.displayType = value;
      fileService.updateDisplayType({ displayType: this.displayType });
    },
  },
  watch: {
    modalActive: {
      handler(next) {
        if(next == this.modalID) {
          this.init({
            ...this.modal.payload
          })
        }
      },
    },
  },
  props: {
    customid: {
      type: String,
      default: "filemanager",
    },
  },
};
</script>
<style lang="scss" scoped>
#filemanager___BV_modal_outer_ {
  z-index: 10010 !important;
}
.error-file {
  li:not(:last-child) {
    padding-bottom: 0.5rem;
  }
}
.detail-image {
  .img {
    &.active {
      img {
        border: 2px solid var(--primary);
      }
    }
  }
}
.drag-over {
  background-color: #f8f9fa;
}
</style>
